import { render } from "./TestStatus.vue?vue&type=template&id=474e4702"
import script from "./TestStatus.vue?vue&type=script&lang=js"
export * from "./TestStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/tests/TestStatus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "474e4702"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('474e4702', __exports__)) {
    api.reload('474e4702', __exports__)
  }
  
  module.hot.accept("./TestStatus.vue?vue&type=template&id=474e4702", () => {
    api.rerender('474e4702', render)
  })

}


export default __exports__